
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-listed",
      function () {
        return require("private-next-pages/get-listed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-listed"])
      });
    }
  